<template>

    <div>
        <b-select :options="templateOptions" :value="value" text-field="title" value-field="id"
            @change="$emit('input', $event)" />
    </div>

</template>

<script lang="ts">
import { Vue, Prop, Component } from "vue-property-decorator";
import axios from "axios";
import { UserTask } from "@/models/UserTask";
import { NotificationOptions } from "@/util/NotificationOptionsPresets";

@Component({
    name: "TaskTemplateField",
})
export default class TaskTemplateField extends Vue {

    @Prop({ default: null }) value!: number | null;

    protected templates: UserTask[] = [];

    mounted() {
        this.getTaskTemplates();
    }

    async getTaskTemplates() {
        try {
            const response = await axios.get<UserTask[]>("/task/templates");
            this.templates = response.data;
        } catch (err) {
            console.error(err);
            this.$notification(NotificationOptions.error(err));
        }
    }

    get templateOptions() {
        return [
            { title: "", id: null },
            ...this.templates
        ]
    }

}

</script>